/* eslint-disable react/function-component-definition,jsx-a11y/control-has-associated-label */
import React, { useMemo } from "react";
import clsx from "clsx";
import styles from "./Table.scss";

const ARROW_UP_STYLES = {
  asc: styles.sortHighlighted,
  desc: styles.sortOff,
};

const ARROW_DOWN_STYLES = {
  asc: styles.sortOff,
  desc: styles.sortHighlighted,
};

const sortCaret = (loading) => (order) =>
  (
    <button type="button" className={styles.sortCaret} disabled={loading}>
      <span className={clsx("fa fa-arrow-down", ARROW_DOWN_STYLES[order])} />
      &nbsp;
      <span className={clsx("fa fa-arrow-up", ARROW_UP_STYLES[order])} />
    </button>
  );

const useSort = ({ loading }) => {
  const sort = useMemo(
    () => ({
      sortCaret: sortCaret(loading),
    }),
    [loading]
  );

  return sort;
};

export default useSort;
